import * as React from 'react';

export function IconUserCard() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 80 80">
      <path fill="#0468FF" fillOpacity=".1" d="M0 8h48l16 16v56H0V8z" />
      <path fill="#0468FF" d="M40 32h40v48H40z" />
      <path fill="#fff" d="M48 68h24v2H48zM48 72h16v2H48z" />
      <path fill="#0468FF" d="M56 28h8v8h-8z" />
      <mask id="IconUserCard" width="24" height="24" x="48" y="39" maskUnits="userSpaceOnUse">
        <circle cx="60" cy="51" r="12" fill="#fff" />
      </mask>
      <g mask="url(#IconUserCard)">
        <circle cx="60" cy="51" r="12" fill="#fff" />
        <circle cx="60" cy="49" r="4" fill="#0468FF" />
        <circle cx="60" cy="59" r="8" fill="#0468FF" />
      </g>
    </svg>
  );
}
